'use strict';

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var $pdp = {
  gallery_nav: '.pdp-gallery-thumbnail',
  details_nav_item: '.pdp-details-nav-item'
};

/**
*
* ------------------------------------------------------------------------------
*
*
* @namespace pdp
*/

(0, _jquery2.default)(document).ready(function () {
  listeners();
});

function listeners() {
  (0, _jquery2.default)(document).on('click', $pdp.gallery_nav, function () {
    var slideIndex = (0, _jquery2.default)(this).attr('data-index');
    (0, _jquery2.default)('.pdp-gallery-slider').slick('slickGoTo', slideIndex);
  });

  (0, _jquery2.default)(document).on('click', $pdp.details_nav_item, function () {
    var index = (0, _jquery2.default)(this).attr('data-index');
    (0, _jquery2.default)('.pdp-detail, .pdp-details-nav-item').removeClass('show');
    (0, _jquery2.default)('.pdp-detail[data-index="' + index + '"], .pdp-details-nav-item[data-index="' + index + '"]').addClass('show');
  });

  (0, _jquery2.default)('[pdp-option-variants]').change(function () {
    var active_variant = (0, _jquery2.default)(this).val();
    var product_handle = (0, _jquery2.default)(this).attr('data-product-handle');
    updatePricing(active_variant, product_handle);
  });
}

(0, _jquery2.default)(document).ready(function () {
  (0, _jquery2.default)('.pdp-gallery-slider').slick({
    slidesToShow: 1,
    autoplay: false,
    arrows: false,
    fade: true,
    cssEase: 'linear',
    lazyLoad: 'ondemand',
    dots: true
  });

  // Default to Variant if defined via url parameter '?variant='
  if (window.location.href.indexOf('?variant=') >= 0) {
    var href = document.location.href;
    var param_variant = href.substr(href.indexOf("?variant=") + 9);
    (0, _jquery2.default)('[pdp-option-variants]').val(param_variant);
  }
});

function updatePricing(active_variant, product_handle) {
  _jquery2.default.getJSON('/products/' + product_handle + '.js', function (prod) {
    for (var i = 0, l = prod.variants.length; i < l; i++) {
      if (prod.variants[i].id == active_variant) {
        var update_price = Shopify.formatMoney(prod.variants[i].price).replace(".00", "");
        // if(prod.variants[i].compare_at_price == null) {
        //   $price[0].compare_at_price = 0;
        // }
        (0, _jquery2.default)('[dynamic-variant-price]').text(update_price);
        var url = document.location.protocol + "//" + document.location.hostname + document.location.pathname + "?variant=" + active_variant;
        // document.location = url;
        window.history.replaceState(null, null, url);

        break;
      }
    }
  });
}